const dashboardConstants = {
  baseUrl: "/api/V1/Dashboards",
};
export default dashboardConstants;
